import React from 'react'
import LocationCell from '../tableCells/name'
import AddressCell from '../tableCells/address'
import PaidLeaveTypesCell from '../tableCells/paidLeaveTypes'
import { SortableTableHeader } from '../../../../../app/components/statelessDataTable/components/tableColumn'
import PAID_LEAVE from '../../../../constants'

const paidLeaveLocationsTableColumns = ({ sortOptions, eventHandlers }) => {
  const columns = [
    {
      Header: () => (
        <SortableTableHeader {...{
          field: PAID_LEAVE.TABLE_HEADERS.LOCATION_NAME.FIELD,
          text: PAID_LEAVE.TABLE_HEADERS.LOCATION_NAME.HEADER,
          sortOptions,
          eventHandlers
        }}
        />
      ),
      accessor: PAID_LEAVE.TABLE_HEADERS.LOCATION_NAME.ACCESSOR,
      Cell: ({ cell }) => <LocationCell location={cell.row.original} />,
      width: 540,
      minWidth: 0,
      maxWidth: 0,
      canSort: true
    },
    {
      Header: () => (
        <SortableTableHeader {...{
          field: PAID_LEAVE.TABLE_HEADERS.ADDRESS.ACCESSOR,
          text: PAID_LEAVE.TABLE_HEADERS.ADDRESS.HEADER,
          sortOptions,
          eventHandlers
        }}
        />
      ),
      accessor: PAID_LEAVE.TABLE_HEADERS.ADDRESS.ACCESSOR,
      Cell: ({ cell }) => <AddressCell location={cell.row.original} />,
      width: 450,
      minWidth: 0,
      maxWidth: 0,
      canSort: true
    },
    {
      Header: () => (
        <span data-testid="table-header-paidLeaveType">{PAID_LEAVE.TABLE_HEADERS.PAID_LEAVE_TYPE.HEADER}</span>
      ),
      accessor: PAID_LEAVE.TABLE_HEADERS.PAID_LEAVE_TYPE.KEY,
      Cell: ({ cell }) => <PaidLeaveTypesCell location={cell.row.original} />,
      width: 450,
      canSort: false
    }
  ]

  return columns
}

export default paidLeaveLocationsTableColumns
